import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, Quote, ArrowRight, X, ChevronLeft, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

// Fallback data matching the seeded CMS content
const testimonialsFallback = [
  {
    id: '1',
    name: { da: 'Gilleleje Sejlklub' },
    contact_person: { da: 'Bente Billenstein' },
    text: { da: '<p>Gilleleje Sejlklub har haft HnPromotion.dk som leverandør (v/ Bente Billenstein) i gennem mere end 20 år, og vi har fuldt ud været meget tilfredse med både tøj og service, det har vore sejlervenner i sejlklubben også.</p>' },
    logo: ['https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/44a5a2d0-27f3-4713-83fb-7b8f6fa0882d.jpg'],
    rating: 5
  },
  {
    id: '2',
    name: { da: 'Skovlunde Erhvervsforening' },
    contact_person: { da: 'Morten Hansen' },
    text: { da: '<p>Super hurtig levering og fantastisk personlig service! Vi fik poloshirts med broderet logo til hele foreningen, og kvaliteten overgik alle vores forventninger. Kan varmt anbefales til andre erhvervsdrivende.</p>' },
    logo: [],
    rating: 5
  },
  {
    id: '3',
    name: { da: 'Craft Sportswear Danmark' },
    contact_person: { da: 'Lars Poulsen' },
    text: { da: '<p>Vi har samarbejdet med HnPromotion i en årrække. Deres professionelle tilgang til profilbeklædning og evne til altid at finde den rette løsning gør dem til en uundværlig partner for os i hverdagen. De forstår vigtigheden af detaljer og leverer altid til tiden.</p>' },
    logo: ['https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/bbb5ffed-8be5-4e59-9bc5-b964c19233fc.png'],
    rating: 5
  },
  {
    id: '4',
    name: { da: 'Københavns Padelklub' },
    contact_person: { da: 'Sofie Nielsen' },
    text: { da: '<p>Fantastisk kvalitet af spillesæt! Vi bestilte både t-shirts, shorts og hoodies til vores turneringshold. HnPromotion hjalp os igennem hele processen fra valg af mærke til placering af klublogo og sponsorlogoer. Deres ekspertise sikrede, at trykket holder perfekt selv efter utallige vaske, og spillerne elsker komforten. Vi kommer helt sikkert tilbage næste sæson!</p>' },
    logo: [],
    rating: 4
  },
  {
    id: '5',
    name: { da: 'Texet Distribution' },
    contact_person: { da: 'Jan Jensen' },
    text: { da: '<p>Altid professionel rådgivning og tøj i absolut topklasse. Et sikkert valg hver gang.</p>' },
    logo: ['https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/440d8707-72a6-421b-a8f3-1bdfcaedb106.png'],
    rating: 5
  },
  {
    id: '6',
    name: { da: 'HåndværkerGruppen ApS' },
    contact_person: { da: 'Christian Østergaard' },
    text: { da: '<p>Slidstærkt arbejdstøj der holder til hverdagens hårde slid på byggepladsen. Vi har fået trykt logo på både jakker, bukser og t-shirts. Servicen er altid i top, og Bente er utrolig fleksibel og hurtig til at svare på vores henvendelser.</p>' },
    logo: [],
    rating: 5
  },
  {
    id: '7',
    name: { da: 'ID Identity A/S' },
    contact_person: { da: 'Thomas Vestergaard' },
    text: { da: '<p>HnPromotion har været en loyal og stabil forhandler af vores produkter i mange år. Deres dybe kendskab til sortimentet og store fokus på kundetilfredshed sikrer, at slutkunden altid får den helt rigtige rådgivning og de bedste produkter. Vi sætter stor pris på det tætte og professionelle samarbejde.</p>' },
    logo: ['https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/a3aa5a70-9ead-4836-a67f-f5c192cfdcc1.png'],
    rating: 5
  },
  {
    id: '8',
    name: { da: 'Nordic Business Solutions' },
    contact_person: { da: 'Mette Frederiksen' },
    text: { da: '<p>Super service og lækre gaver til vores medarbejdere!</p>' },
    logo: [],
    rating: 4
  },
  {
    id: '9',
    name: { da: 'Jobman Workwear' },
    contact_person: { da: 'Anders Berg' },
    text: { da: '<p>Et stærkt og professionelt samarbejde om slidstærkt arbejdstøj. HnPromotion leverer altid en sublim service og formår at guide kunderne til de helt rigtige løsninger, uanset branche og behov.</p>' },
    logo: ['https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/a7dc0c4b-b3d1-4bda-9d91-5d717393acfb.png'],
    rating: 5
  },
  {
    id: '10',
    name: { da: 'Sjællands Tømrerforretning' },
    contact_person: { da: 'Peter Madsen' },
    text: { da: '<p>Rigtig god kvalitet og hurtig ekspedition af vores nye firmatøj. Vi er yderst tilfredse.</p>' },
    logo: [],
    rating: 5
  },
  {
    id: '11',
    name: { da: 'Tenson Outdoor' },
    contact_person: { da: 'Kristina Nilsson' },
    text: { da: '<p>Professionel leverandør af outdoor- og profilbeklædning. Deres sans for kvalitet og detaljer skinner igennem i alt, hvad de laver. Altid en fornøjelse at handle med.</p>' },
    logo: ['https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/1508dcc4-2af2-48a9-8891-4b9057d0522a.png'],
    rating: 5
  }
];

export default function Anbefalinger() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTestimonial, setSelectedTestimonial] = useState(null);

  const getPlainText = (html) => {
    if (!html) return '';
    return html.replace(/<[^>]*>/g, '');
  };

  const handlePrev = () => {
    if (!selectedTestimonial || testimonials.length === 0) return;
    const currentIndex = testimonials.findIndex(t => t.id === selectedTestimonial.id);
    const prevIndex = (currentIndex - 1 + testimonials.length) % testimonials.length;
    setSelectedTestimonial(testimonials[prevIndex]);
  };

  const handleNext = () => {
    if (!selectedTestimonial || testimonials.length === 0) return;
    const currentIndex = testimonials.findIndex(t => t.id === selectedTestimonial.id);
    const nextIndex = (currentIndex + 1) % testimonials.length;
    setSelectedTestimonial(testimonials[nextIndex]);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedTestimonial) return;
      if (e.key === 'ArrowLeft') {
        handlePrev();
      } else if (e.key === 'ArrowRight') {
        handleNext();
      } else if (e.key === 'Escape') {
        setSelectedTestimonial(null);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedTestimonial, testimonials]);

  useEffect(() => {
    if (selectedTestimonial) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [selectedTestimonial]);

  useEffect(() => {
    fetch('https://api.dev.auxo.dk/public/content/testimonials')
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch testimonials');
        return res.json();
      })
      .then((data) => {
        if (data && data.length > 0) {
          // Normalize data structure
          const normalized = data.map(item => ({
            id: item.id,
            name: typeof item.name === 'object' ? item.name : { da: item.name },
            contact_person: typeof item.contact_person === 'object' ? item.contact_person : { da: item.contact_person },
            text: typeof item.text === 'object' ? item.text : { da: item.text },
            logo: Array.isArray(item.logo) ? item.logo : (item.logo ? [item.logo] : []),
            rating: item.rating || 5
          }));
          setTestimonials(normalized);
        } else {
          setTestimonials(testimonialsFallback);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setTestimonials(testimonialsFallback);
        setLoading(false);
      });
  }, []);

  return (
    <div className="bg-white min-h-screen">
      {/* Hero Section */}
      <div className="relative bg-[#1e335e] py-20 sm:py-24 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10 pointer-events-none">
          <div className="absolute inset-0 bg-gradient-to-r from-orange-500 to-[#1e335e] mix-blend-multiply" />
          <img 
            src="https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/97b445b1-2b17-4470-be0b-340e0049d2a9.jpeg" 
            alt="Background pattern" 
            className="w-full h-full object-cover"
          />
        </div>
        <div className="mx-auto max-w-7xl px-6 lg:px-8 relative z-10 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="text-sm font-semibold tracking-widest text-orange-500 uppercase block mb-2">
              Kundetilfredshed i fokus
            </span>
            <h1 className="text-4xl font-black tracking-tight sm:text-6xl uppercase">
              Anbefalinger
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-lg leading-8 text-slate-300">
              Gennem mere end 20 år har vi leveret beklædning og gaver af højeste kvalitet til virksomheder, foreninger og sportsklubber. Læs hvad vores samarbejdspartnere siger om os.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Testimonials Grid */}
      <div className="mx-auto max-w-7xl px-6 py-16 sm:py-24 lg:px-8">
        {loading ? (
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {Array(6).fill(0).map((_, i) => (
              <div key={i} className="h-64 bg-gray-50 animate-pulse rounded-none border border-gray-100" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 items-stretch">
            {testimonials.map((testimonial, index) => {
              const hasLogo = testimonial.logo && testimonial.logo.length > 0;
              const isLong = getPlainText(testimonial.text.da).length > 300;
              return (
                <motion.div
                  key={testimonial.id}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 0.5, delay: Math.min(index * 0.05, 0.3) }}
                  className="flex flex-col justify-between bg-white p-8 border border-gray-100 shadow-sm hover:shadow-md transition-shadow relative group"
                >
                  <div>
                    {/* Quote Icon & Rating */}
                    <div className="flex items-center justify-between mb-6">
                      <div className="text-orange-500/20 group-hover:text-orange-500/30 transition-colors">
                        <Quote className="h-10 w-10 transform -scale-x-100" />
                      </div>
                      <div className="flex gap-1">
                        {Array(5).fill(0).map((_, i) => (
                          <Star 
                            key={i} 
                            className={`h-4 w-4 ${
                              i < testimonial.rating 
                                ? 'text-orange-500 fill-orange-500' 
                                : 'text-gray-200'
                            }`} 
                          />
                        ))}
                      </div>
                    </div>

                    {/* Testimonial Text */}
                    <div 
                      className={`text-gray-600 leading-relaxed text-sm prose prose-orange ${
                        isLong ? 'line-clamp-6 mb-2' : 'mb-8'
                      }`}
                      dangerouslySetInnerHTML={{ __html: testimonial.text.da }}
                    />

                    {isLong && (
                      <button 
                        onClick={() => setSelectedTestimonial(testimonial)}
                        className="text-orange-500 hover:text-orange-600 font-bold text-xs uppercase tracking-wider mb-6 inline-flex items-center gap-1 transition-colors cursor-pointer"
                      >
                        Læs mere
                      </button>
                    )}
                  </div>

                  {/* Client Info & Logo */}
                  <div className="border-t border-gray-100 pt-6 mt-auto flex items-center justify-between gap-4">
                    <div>
                      <h3 className="font-bold text-gray-900 text-base">
                        {testimonial.name.da}
                      </h3>
                      {testimonial.contact_person && testimonial.contact_person.da && (
                        <p className="text-xs text-gray-500 mt-0.5">
                          v/ {testimonial.contact_person.da}
                        </p>
                      )}
                    </div>
                    {hasLogo && (
                      <div className="flex-shrink-0 bg-gray-50 p-2 border border-gray-100 h-20 w-36 flex items-center justify-center">
                        <img 
                          src={testimonial.logo[0]} 
                          alt={`${testimonial.name.da} logo`} 
                          className="max-h-16 max-w-full object-contain transition-all duration-300"
                        />
                      </div>
                    )}
                  </div>
                </motion.div>
              );
            })}
          </div>
        )}
      </div>

      {/* CTA Section */}
      <div className="bg-gray-50 border-t border-gray-100 py-16 sm:py-24">
        <div className="mx-auto max-w-4xl px-6 text-center lg:px-8">
          <h2 className="text-3xl font-extrabold tracking-tight text-[#1e335e] sm:text-4xl uppercase">
            Vil du også være en af vores tilfredse partnere?
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-gray-600">
            Vi står klar til at hjælpe din virksomhed eller forening med den helt rigtige løsning inden for profilbeklædning, sportstøj og firmagaver.
          </p>
          <div className="mt-10 flex justify-center">
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-x-2 rounded-none bg-orange-500 px-8 py-4 text-sm font-semibold text-white hover:bg-orange-600 transition-all transform hover:-translate-y-1 shadow-lg hover:shadow-orange-200 duration-200 uppercase"
            >
              Kontakt os i dag
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>

      {/* Modal */}
      <AnimatePresence>
        {selectedTestimonial && (() => {
          const currentIndex = testimonials.findIndex(t => t.id === selectedTestimonial.id);
          return (
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6">
              {/* Backdrop */}
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={() => setSelectedTestimonial(null)}
                className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm"
              />

              {/* Navigation Wrapper */}
              <div className="relative w-full max-w-2xl flex items-center justify-center z-10">
                {/* Desktop Left Button */}
                <button
                  onClick={handlePrev}
                  className="hidden md:flex absolute -left-16 bg-white hover:bg-orange-500 hover:text-white text-gray-700 p-3 rounded-full shadow-lg border border-gray-100 transition-all cursor-pointer items-center justify-center z-20 hover:scale-110 active:scale-95 duration-200"
                  aria-label="Forrige"
                >
                  <ChevronLeft className="h-6 w-6" />
                </button>

                {/* Modal Card */}
                <motion.div
                  initial={{ opacity: 0, scale: 0.95, y: 20 }}
                  animate={{ opacity: 1, scale: 1, y: 0 }}
                  exit={{ opacity: 0, scale: 0.95, y: 20 }}
                  transition={{ type: 'spring', duration: 0.5 }}
                  className="relative bg-white w-full p-8 sm:p-10 border border-gray-100 shadow-2xl max-h-[90vh] overflow-y-auto flex flex-col justify-between"
                >
                  {/* Close Button & Page Indicator */}
                  <div className="absolute top-4 right-4 flex items-center gap-3">
                    <span className="text-xs text-gray-400 font-semibold bg-gray-50 px-2.5 py-1 border border-gray-100">
                      {currentIndex + 1} / {testimonials.length}
                    </span>
                    <button
                      onClick={() => setSelectedTestimonial(null)}
                      className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-50 rounded-full cursor-pointer"
                      aria-label="Luk"
                    >
                      <X className="h-6 w-6" />
                    </button>
                  </div>

                  <div>
                    {/* Quote Icon & Rating */}
                    <div className="flex items-center justify-between mb-6 pr-24">
                      <div className="text-orange-500/20">
                        <Quote className="h-12 w-12 transform -scale-x-100" />
                      </div>
                      <div className="flex gap-1">
                        {Array(5).fill(0).map((_, i) => (
                          <Star 
                            key={i} 
                            className={`h-5 w-5 ${
                              i < selectedTestimonial.rating 
                                ? 'text-orange-500 fill-orange-500' 
                                : 'text-gray-200'
                            }`} 
                          />
                        ))}
                      </div>
                    </div>

                    {/* Full Testimonial Text */}
                    <div 
                      className="text-gray-600 leading-relaxed mb-8 text-base prose prose-orange max-w-none"
                      dangerouslySetInnerHTML={{ __html: selectedTestimonial.text.da }}
                    />
                  </div>

                  {/* Client Info & Logo */}
                  <div className="border-t border-gray-100 pt-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                    <div>
                      <h3 className="font-bold text-gray-900 text-lg">
                        {selectedTestimonial.name.da}
                      </h3>
                      {selectedTestimonial.contact_person && selectedTestimonial.contact_person.da && (
                        <p className="text-sm text-gray-500 mt-0.5">
                          v/ {selectedTestimonial.contact_person.da}
                        </p>
                      )}
                    </div>
                    {selectedTestimonial.logo && selectedTestimonial.logo.length > 0 && (
                      <div className="flex-shrink-0 bg-gray-50 p-3 border border-gray-100 h-20 w-36 flex items-center justify-center">
                        <img 
                          src={selectedTestimonial.logo[0]} 
                          alt={`${selectedTestimonial.name.da} logo`} 
                          className="max-h-16 max-w-full object-contain"
                        />
                      </div>
                    )}
                  </div>

                  {/* Mobile Navigation controls */}
                  <div className="flex md:hidden items-center justify-between border-t border-gray-100 pt-4 mt-6">
                    <button
                      onClick={handlePrev}
                      className="flex items-center gap-1 text-sm font-semibold text-gray-600 hover:text-orange-500 transition-colors cursor-pointer"
                    >
                      <ChevronLeft className="h-5 w-5" />
                      Forrige
                    </button>
                    <span className="text-xs text-gray-400 font-medium">
                      {currentIndex + 1} af {testimonials.length}
                    </span>
                    <button
                      onClick={handleNext}
                      className="flex items-center gap-1 text-sm font-semibold text-gray-600 hover:text-orange-500 transition-colors cursor-pointer"
                    >
                      Næste
                      <ChevronRight className="h-5 w-5" />
                    </button>
                  </div>
                </motion.div>

                {/* Desktop Right Button */}
                <button
                  onClick={handleNext}
                  className="hidden md:flex absolute -right-16 bg-white hover:bg-orange-500 hover:text-white text-gray-700 p-3 rounded-full shadow-lg border border-gray-100 transition-all cursor-pointer items-center justify-center z-20 hover:scale-110 active:scale-95 duration-200"
                  aria-label="Næste"
                >
                  <ChevronRight className="h-6 w-6" />
                </button>
              </div>
            </div>
          );
        })()}
      </AnimatePresence>
    </div>
  );
}
